<template>
    <div class="thumbnailOrg">
        <div class="org_box">
            <img
                src="../assets/close.png"
                alt=""
                class="close"
                @click="close_org"
            />
            <div class="label_list">
                <div class="label_box">
                    <div v-for="(i, index) in org_imgs" class="label_boxs" :key="index">
                        <div class="label_f" @click="change_data(i.data, index)">
                            {{ i.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="pic_list">
                <div class="pic_box" v-for="(pic,index) in img_list" :key="index">
                    <img :src="pic.preview_pic" alt="" @click="change_org(pic.pic)" />
                </div>
            </div>
            <div class="box_right">
                <div
                    class="box_right1"
                    :style="{ backgroundImage: 'url(' + thumbnailOrg + ')' }"
                    ref="thumbnailOrg"
                ></div>
                <img :src="org_imgm_url" alt="" class="box_right2" v-if="baimo_on" />
<!--                <div class="baimo_detail">-->
<!--                    <h2>{{ description }}</h2>-->
<!--                    <div class="baimo_detail_box">-->
<!--                        <p>-->
<!--                            素材ID：<span>{{ name }}</span>-->
<!--                        </p>-->
<!--                        <p>-->
<!--                            摄影师：<span>{{ author }}</span>-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="block">
                <div class="c_size">+</div>
                <el-slider v-model="value" vertical :min="5" height="500px"> </el-slider>
                <div class="c_size">-</div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
  name: "Thumbnail",
    props:['thumbnail'],
    data(){
        return {
            org_imgs: [],
            org_imgm_url: [],
            img_list: "",
            thumbnailOrg: this.thumbnail,
            name: "",
            description: "",
            author: "",
            baimo_on: false,
            value: 100,
        };
    },
    methods:{
        change_data(data) {
            this.img_list = data;
        },

        close_org() {
            this.$parent.org_close();
            this.baimo_on = false;
        },
        change_org(url) {
            this.baimo_on = true;
            this.org_imgm_url = url;
        }
    },
    watch: {
        value: {
            handler() {
                this.$refs.thumbnailOrg.style.backgroundSize = this.value + "%";
            }
        }
    },
    created() {
        this.org_imgs = [];
        this.$get('https://pd-api.shenbipro.com/api/albuginea').then(res=>{
            this.org_imgs = res.data;
        })
    }
};
</script>

<style scoped src="../assets/css/thumbnail.css"></style>
